import { InspectionType } from 'src/app/shared/data/dto/enums/inspection-type.enum';

export enum InspectionSubType {
	Audit = 1,
	InspectionOnTheSpot = 2,
	AdministrativeCheck = 3,
	NMAAgreement = 4,
	ReportComplaintInvestigation = 5,
	ControlElimination = 6,
	Other = 7,
}

/** The subtypes an event of each inspection type can be given, in display order. */
export const INSPECTION_SUB_TYPES_BY_TYPE: Readonly<Record<InspectionType, readonly InspectionSubType[]>> = {
	[InspectionType.Inspection]: [
		InspectionSubType.Audit,
		InspectionSubType.InspectionOnTheSpot,
		InspectionSubType.AdministrativeCheck,
		InspectionSubType.ReportComplaintInvestigation,
		InspectionSubType.ControlElimination,
		InspectionSubType.Other,
	],
	[InspectionType.Supervision]: [InspectionSubType.Other],
	[InspectionType.Monitoring]: [InspectionSubType.ReportComplaintInvestigation],
};
